<div class="mastercitieswrapper">
    <div class="table-container">
      <div class="table-top-wrapper mb-3">
          <div>
              <h2 class="text-heading-3 text-start mb-1 text-capitalize">Cities - {{ totalCitiesCount }}</h2>
          </div>
          <div class="search-controls">
              <form action="" class="search-block" (submit)="onSearchSubmit()">
                  <div class="search-input">
                      <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by City Name">
                  </div>
                  <button type="submit" class="icon-btn">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                      </svg>                            
                  </button>
              </form>
                              <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
              <button class="primary-btn addproduct" (click)="openDialog(cities)">Add City</button>
          </div>
      </div>
  
      <div class="table-wrapper">
          <table class="table table-responsive">
            <thead class="position-relative">
              <tr>
                <th class="" scope="col">Region</th>
                <th class="" scope="col">Country</th>
                <th class="" scope="col">City</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cities of cities">
                <td class="text-start spacecontent">{{ cities.region_name }}</td>
                <td class="text-start spacecontent">{{ cities.country_name}}</td> 
                <td class="text-start spacecontent">{{ cities.name }}</td>
                <td class="text-start spacecontent" (click)="openEditDialog(cities)"><img src="../../../../assets/images/editIcon.svg"></td> 
                <td class="text-start spacecontent" (click)="openDeleteDialog(cities)"><img src="../../../../assets/images/deleteIcon.svg"></td>  
              </tr>
            </tbody>
          </table>
      </div>
    </div>
    <div class="" *ngIf="paginationData.totalPage > 1"> 
      <app-pagination [totalPages]="paginationData.totalPage" (queryPage)="getQueryPage($event)"></app-pagination>
    </div>
  </div>